var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-page',{staticClass:"px-4 pb-4"},[_c('six-digit-confirm-view',{attrs:{"loading":_vm.loading,"button-text":_vm.$t('Continue')},on:{"resend":_vm.codeResend,"submit":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }